<div class="orchestrate-container">
    <img
        src="/assets/orchestrate_logo_wide.svg"
        alt="Orchestrate logo"
    />

    <div class="title">
        <h1>Select a group to view</h1>
        <app-user-dropdown>
            @if ((user$ | async)?.isGlobalAdmin) {
                <a
                    mat-menu-item
                    routerLink="/administration"
                >
                    <mat-icon>settings_applications</mat-icon>
                    Administration
                </a>
            }
        </app-user-dropdown>
    </div>

    @if (isGlobalAdmin$ | async) {
        <h2>My groups</h2>
    }
    <div
        *appLoadingUntilFirstEmit="let tenants of accessibleTenants$"
        class="my-groups-container"
    >
        @if (tenants.length > 0) {
            <ul>
                @for (wrapper of tenants; track wrapper) {
                    <li>
                        <a [routerLink]="[wrapper.tenant.abbreviation, 'home']">
                            <img
                                [src]="wrapper.image"
                                [alt]="wrapper.tenant.name"
                            />
                            <h3>{{ wrapper.tenant.name }}</h3>
                        </a>
                    </li>
                }
            </ul>
        } @else {
            You don't have permission to view any organisations.
        }
    </div>

    @if (isGlobalAdmin$ | async) {
        <h2>All groups</h2>
        <ul *appLoadingUntilFirstEmit="let tenants of allTenants$">
            @for (wrapper of tenants; track wrapper) {
                <li>
                    <a [routerLink]="[wrapper.tenant.abbreviation, 'home']">
                        <img
                            [src]="wrapper.image"
                            [alt]="wrapper.tenant.name"
                        />
                        <h3>{{ wrapper.tenant.name }}</h3>
                    </a>
                </li>
            }
        </ul>
    }
</div>
